var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cc"}},[_c('comp-menu'),_c('div',{class:(_vm.windowWidth < 1024 ? 'container-fluid' : 'container')},[_c('router-view')],1),_c('comp-sidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }